import React from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import {UserProvider} from './UserContext';
import MainLayout from './components/MainLayout';
import Login from './components/Login';
import RecuperarSenha from './components/RecuperarSenha';
import RedefinirSenha from './components/RedefinirSenha';
import PrimeiroAcesso from './components/PrimeiroAcesso';
import CadastroEmpresa from './components/empresa/CadastroEmpresa';
import DetalharEmpresa from './components/empresa/DetalharEmpresa';
import ListaEmpresas from './components/empresa/ListaEmpresas';
import CadastroUsuario from './components/usuario/CadastroUsuario';
import DetalharUsuario from './components/usuario/DetalharUsuario';
import ListaUsuarios from './components/usuario/ListaUsuarios';
import RevisarClientePendente from './components/usuario/RevisarClientePendente';
import CadastroUsina from './components/usina/CadastroUsina';
import DetalharUsina from './components/usina/DetalharUsina';
import ListaUsinas from './components/usina/ListaUsinas';
import CadastroProducaoUsina from './components/producaoUsina/CadastroProducaoUsina';
import DetalharProducaoUsina from './components/producaoUsina/DetalharProducaoUsina';
import ListaProducaoUsinas from './components/producaoUsina/ListaProducaoUsinas';
import CadastroConsumoCliente from './components/consumoCliente/CadastroConsumoCliente';
import DetalharConsumoCliente from './components/consumoCliente/DetalharConsumoCliente';
import ListaConsumoClientes from './components/consumoCliente/ListaConsumoClientes';
import CadastroRateio from './components/rateio/CadastroRateio';
import DetalharRateio from './components/rateio/DetalharRateio';
import ListaRateios from './components/rateio/ListaRateios';
import DetalharBoleto from './components/boleto/DetalharBoleto';
import Dashboard from './components/dashboard/Dashboard';
import styles from './components/css/global.module.css';
import backgroundImage from './assets/images/background.png';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ListaFaturamento from "./components/relatorios/ListaFaturamento";
import ListaConsumoProducao from "./components/relatorios/ListaConsumoProducao";
import ListaReceitaCliente from "./components/relatorios/ListaReceitaCliente";
import ListaEconomiaMensal from "./components/relatorios/ListaEconomiaMensal";
import ListaUnidadeConsumidora from "./components/unidadeConsumidora/ListaUnidadeConsumidora";
import CadastroUnidadeConsumidora from "./components/unidadeConsumidora/CadastroUnidadeConsumidora";
import DetalharUnidadeConsumidora from "./components/unidadeConsumidora/DetalharUnidadeConsumidora";
import FaturasUpload from "./components/faturas/FaturasUpload";
import ListarFaturas from "./components/faturas/ListarFaturas";
import BuscarFaturasDF from "./components/robos/NeoenergiaCaptura";
import ListarStatusFatura from "./components/robos/ListaStatusFaturaUsina";
import ListaStatusFaturaEmpresa from "./components/robos/ListaStatusFaturaEmpresa";
import AnaliseRateio from "./components/rateio/AnaliseRateio";
import DashboardRateio from "./components/rateio/DashboardRateio";
import AuditoriaDistribuidoraDashboard from './components/dashboard/AuditoriaDistribuidoraDashboard';


function App() {
    return (
        <UserProvider>
            <div className={styles.body} style={{backgroundImage: `url(${backgroundImage})`}}>
                <Router>
                    <Routes>
                        <Route path="/login" element={<Login/>}/>
                        <Route path="/recuperar-senha" element={<RecuperarSenha/>}/>
                        <Route path="/redefinir-senha" element={<RedefinirSenha/>}/>
                        <Route path="/alterar-senha-primeiro-acesso/:id" element={<PrimeiroAcesso/>}/>
                        <Route path="/home" element={<MainLayout/>}>
                            {/*<Route index element={<Navigate to="/home/dashboard" replace/>}/>*/}
                            <Route path="dashboard" element={<Dashboard/>}/>
                            <Route path="cadastrar-empresa" element={<CadastroEmpresa/>}/>
                            <Route path="cadastrar-empresa/:id" element={<CadastroEmpresa/>}/>
                            <Route path="detalhar-empresa/:id" element={<DetalharEmpresa/>}/>
                            <Route path="listar-empresa" element={<ListaEmpresas/>}/>
                            <Route path="cadastrar-usuario" element={<CadastroUsuario/>}/>
                            <Route path="cadastrar-usuario/:id" element={<CadastroUsuario/>}/>
                            <Route path="detalhar-usuario/:id" element={<DetalharUsuario/>}/>
                            <Route path="revisar-cliente-pendente/:id" element={<RevisarClientePendente/>}/>
                            <Route path="listar-usuario" element={<ListaUsuarios/>}/>
                            <Route path="cadastrar-usina" element={<CadastroUsina/>}/>
                            <Route path="cadastrar-usina/:id" element={<CadastroUsina/>}/>
                            <Route path="detalhar-usina/:id" element={<DetalharUsina/>}/>
                            <Route path="listar-usina" element={<ListaUsinas/>}/>
                            <Route path="cadastrar-producao-usina" element={<CadastroProducaoUsina/>}/>
                            <Route path="cadastrar-producao-usina/:id" element={<CadastroProducaoUsina/>}/>
                            <Route path="detalhar-producao-usina/:id" element={<DetalharProducaoUsina/>}/>
                            <Route path="listar-producao-usina" element={<ListaProducaoUsinas/>}/>
                            <Route path="cadastrar-cliente-consumo" element={<CadastroConsumoCliente/>}/>
                            <Route path="cadastrar-cliente-consumo/:id" element={<CadastroConsumoCliente/>}/>
                            <Route path="detalhar-cliente-consumo/:id" element={<DetalharConsumoCliente/>}/>
                            <Route path="listar-cliente-consumo" element={<ListaConsumoClientes/>}/>
                            <Route path="cadastrar-rateio" element={<CadastroRateio/>}/>
                            <Route path="cadastrar-rateio/:id" element={<CadastroRateio/>}/>
                            <Route path="detalhar-rateio/:id" element={<DetalharRateio/>}/>
                            <Route path="listar-rateio" element={<ListaRateios/>}/>
                            <Route path="detalhar-boleto/:id" element={<DetalharBoleto/>}/>
                            <Route path="listar-faturamento" element={<ListaFaturamento/>}/>
                            <Route path="listar-economia-mensal" element={<ListaEconomiaMensal/>}/>
                            <Route path="listar-consumo-producao" element={<ListaConsumoProducao/>}/>
                            <Route path="listar-receita-cliente" element={<ListaReceitaCliente/>}/>
                            <Route path="listar-unidade-consumidora" element={<ListaUnidadeConsumidora/>}/>
                            <Route path="cadastrar-unidade-consumidora" element={<CadastroUnidadeConsumidora/>}/>
                            <Route path="cadastrar-unidade-consumidora/:id" element={<CadastroUnidadeConsumidora/>}/>
                            <Route path="detalhar-unidade-consumidora" element={<DetalharUnidadeConsumidora/>}/>
                            <Route path="detalhar-unidade-consumidora/:id" element={<DetalharUnidadeConsumidora/>}/>
                            <Route path="importar-faturas" element={<FaturasUpload/>}/>
                            <Route path="listar-faturas" element={<ListarFaturas/>}/>
                            <Route path="neoenergia-df" element={<BuscarFaturasDF/>}/>
                            <Route path="listar-status-faturas" element={<ListarStatusFatura/>}/>
                            <Route path="listar-status-faturas-empresa" element={<ListaStatusFaturaEmpresa/>}/>
                            <Route path="rateio-analise" element={<AnaliseRateio/>}/>
                            <Route path="rateio-dashboard" element={<DashboardRateio/>}/>
                            <Route path="auditoria-distribuidora" element={<AuditoriaDistribuidoraDashboard />} />
                        </Route>
                    </Routes>
                </Router>
                <ToastContainer/>
            </div>
        </UserProvider>
    );
}

export default App;
